import { CircularProgress, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SessionDetailsCard } from '../Components/SessionDetailsCard';
import { SessionItem } from '../Components/SessionItem';
import { SessionsCard } from '../Layout/SessionsCard';
import { SessionWithId } from '../Models/session';
import { openAlert } from '../Store/AlertSlice';
import { selectSession } from '../Store/SessionsSlice';
import { sessionsOnValue } from '../firebase/Database/SessionsOnValue';

export const AdminSessionsPage: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [sessions, setSessions] = useState<SessionWithId[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        try {
            setIsLoading(true);
            const unsubscribe = sessionsOnValue(setSessions);
            return () => {
                unsubscribe();
            };
        } catch (err) {
            dispatch(
                openAlert({
                    displayText: 'Nemohu načíst lekce',
                    severity: 'error',
                }),
            );
        } finally {
            setIsLoading(false);
        }
    }, [dispatch]);

    const onSessionClickHandler = (session: SessionWithId) => {
        dispatch(selectSession({ session: session }));
    };

    const sessionObjects = sessions.map((session, index) => {
        return (
            <SessionItem
                session={session}
                key={session.id}
                onSessionClick={() => onSessionClickHandler(session)}
            />
        );
    });

    return (
        <>
            {isLoading ? (
                <Grid container justifyContent="center">
                    <CircularProgress color="secondary" />
                </Grid>
            ) : (
                <Grid container justifyContent="space-evenly" height="100%">
                    <Grid item xs={10} lg={5}>
                        <SessionsCard title="Lekce">
                            {sessionObjects}
                        </SessionsCard>
                    </Grid>
                    <Grid item xs={10} lg={3}>
                        <SessionDetailsCard />
                    </Grid>
                </Grid>
            )}
        </>
    );
};
